// Appointment-related icons will be moved here by the user
// Examples: NewAppointmentIcon, MultiDayAppointmentIcon, BlockedTimeIcon, NewAppointmentPetIcon, DateRangeIcon, ExactDateIcon, NextAvailableIcon

import { SVGProps } from 'react';

import { cn } from '@ui/lib/utils';
import { FC } from 'react';

/* Appointments Icon */
export const AppointmentsIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="currentColor"
      d="M19 22H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2V2h2v2h6V2h2v2h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2zM5 10v10h14V10H5zm0-4v2h14V6H5zm12 12h-2v-2h2v2zm-4 0h-2v-2h2v2zm-4 0H7v-2h2v2zm8-4h-2v-2h2v2zm-4 0h-2v-2h2v2zm-4 0H7v-2h2v2z"
    ></path>
  </svg>
);

/* New Appointment Icon */
export const NewAppointmentIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    className={cn('w-6 h-6', props.className)}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19 22H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1.6a.4.4 0 0 0 .4-.4V2.4c0-.22.18-.4.4-.4h1.2c.22 0 .4.18.4.4v1.2c0 .22-.18.4.4.4h5.2a.4.4 0 0 0 .4-.4V2.4c0-.22.18-.4.4-.4h1.2c.22 0 .4.18.4.4v1.2c0 .22-.18.4.4.4H19a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2M5.4 10a.4.4 0 0 0-.4.4v9.2c0 .22.18.4.4.4h13.2a.4.4 0 0 0 .4-.4v-9.2a.4.4 0 0 0-.4-.4zm0-4a.4.4 0 0 0-.4.4v1.2c0 .22.18.4.4.4h13.2a.4.4 0 0 0 .4-.4V6.4a.4.4 0 0 0-.4-.4zM13 17.6a.4.4 0 0 1-.4.4h-1.2a.4.4 0 0 1-.4-.4v-1.2a.4.4 0 0 0-.4-.4H9.4a.4.4 0 0 1-.4-.4v-1.2c0-.22.18-.4.4-.4h1.2a.4.4 0 0 0 .4-.4v-1.2c0-.22.18-.4.4-.4h1.2c.22 0 .4.18.4.4v1.2c0 .22.18.4.4.4h1.2c.22 0 .4.18.4.4v1.2a.4.4 0 0 1-.4.4h-1.2a.4.4 0 0 0-.4.4z"
    ></path>
  </svg>
);

/* Pre-paid Icon */
export const PrePaidIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    className={cn('w-6 h-6', props.className)}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19 16.943q-.466.247-.992.445c-1.586.595-3.71.942-6.008.942s-4.422-.347-6.008-.942A9 9 0 0 1 5 16.943V19c0 .026.01.17.292.42.28.249.744.518 1.402.765C8.004 20.675 9.88 21 12 21s3.996-.325 5.306-.815c.658-.247 1.121-.516 1.402-.765.282-.25.292-.395.292-.42zm0-4.663q-.466.247-.992.445c-1.586.594-3.71.942-6.008.942s-4.422-.348-6.008-.942A9 9 0 0 1 5 12.28v2.05l.006.041c.016.063.075.19.286.378.28.249.744.519 1.402.766 1.31.49 3.185.815 5.306.815s3.996-.324 5.306-.815c.658-.247 1.121-.517 1.402-.766.211-.187.27-.315.286-.378l.006-.04zm0-4.666a9 9 0 0 1-.992.444C16.422 8.652 14.298 9 12 9s-4.422-.348-6.008-.942A9 9 0 0 1 5 7.614v2.053l.006.041c.016.063.075.19.286.378.28.249.744.519 1.402.766 1.31.49 3.185.815 5.306.815s3.996-.325 5.306-.815c.658-.247 1.121-.517 1.402-.766.211-.187.27-.315.286-.378L19 9.667zM19 5c0-.026-.01-.17-.292-.42-.28-.249-.744-.518-1.402-.765C15.996 3.325 14.12 3 12 3s-3.997.325-5.306.815c-.658.247-1.121.516-1.402.765C5.01 4.83 5 4.974 5 5s.01.17.292.42c.28.249.744.518 1.402.765C8.004 6.675 9.88 7 12 7s3.996-.325 5.306-.815c.658-.247 1.121-.516 1.402-.765.282-.25.292-.394.292-.42m2 14c0 .803-.437 1.448-.965 1.916-.529.469-1.238.846-2.027 1.142-1.586.595-3.71.942-6.008.942s-4.422-.348-6.008-.942c-.79-.296-1.498-.673-2.027-1.142C3.437 20.448 3 19.803 3 19V5c0-.803.437-1.448.965-1.916.529-.469 1.238-.846 2.027-1.142C7.578 1.348 9.702 1 12 1s4.422.348 6.008.942c.79.296 1.498.673 2.027 1.142C20.563 3.552 21 4.197 21 5z"
    />
  </svg>
);

/* Multi-day Appointment Icon */
export const MultiDayAppointmentIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <g fill="#262338" clipPath="url(#clip0_5229_4167)">
      <path d="M16.43 12H7.56a.56.56 0 0 0-.56.56v.93c0 .31.25.56.56.56h8.87c.31 0 .56-.25.56-.56v-.93a.56.56 0 0 0-.56-.56M12.71 16.09H7.56a.56.56 0 0 0-.56.56v.93c0 .31.25.56.56.56h5.15c.31 0 .56-.25.56-.56v-.93a.56.56 0 0 0-.56-.56"></path>
      <path d="M19 4h-1.6c-.22 0-.4-.18-.4-.4V2.4c0-.22-.18-.4-.4-.4h-1.2c-.22 0-.4.18-.4.4v1.2c0 .22-.18.4-.4.4H9.4c-.22 0-.4-.18-.4-.4V2.4c0-.22-.18-.4-.4-.4H7.4c-.22 0-.4.18-.4.4v1.2c0 .22-.18.4-.4.4H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m0 15.6c0 .22-.18.4-.4.4H5.4c-.22 0-.4-.18-.4-.4v-9.2c0-.22.18-.4.4-.4h13.2c.22 0 .4.18.4.4zm0-12c0 .22-.18.4-.4.4h-13.2c-.22 0-.4-.18-.4-.4V6.4c0-.22.18-.4.4-.4h13.2c.22 0 .4.18.4.4z"></path>
    </g>
    <defs>
      <clipPath id="clip0_5229_4167">
        <path fill="#fff" d="M3 2h18v20H3z"></path>
      </clipPath>
    </defs>
  </svg>
);

/* Multi-day Appointment Icon */
export const BlockedTimeIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="#262338"
      d="M19 22H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2V2h2v2h6V2h2v2h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2M5 10v10h14V10zm0-4v2h14V6z"
    />
    <rect width={6.004} height={5.951} x={7.004} y={12} fill="#262338" rx={1} />
  </svg>
);

/* Date Range Icon */
export const DateRangeIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <circle cx={12} cy={12} r={12} fill="#F7EBFA" />
    <path
      fill="#B031C5"
      d="M8.08 5.58a.833.833 0 0 1 1.423.589v.833h5v-.833a.833.833 0 0 1 1.667 0v.833h.833a1.667 1.667 0 0 1 1.667 1.667v8.333a1.667 1.667 0 0 1-1.667 1.667h-10a1.667 1.667 0 0 1-1.666-1.667V8.667A1.667 1.667 0 0 1 7.33 7h.833v-.833c0-.221.088-.433.244-.589"
    />
    <rect
      width={8.625}
      height={1.496}
      x={7.69}
      y={10.655}
      fill="#fff"
      rx={0.748}
    />
    <rect
      width={6.12}
      height={1.496}
      x={7.69}
      y={13.846}
      fill="#fff"
      rx={0.748}
    />
  </svg>
);

/* Exact Date Icon */
export const ExactDateIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <circle cx={12} cy={12} r={12} fill="#F1F5F9" />
    <path
      fill="#1E293B"
      d="M8.08 5.58a.833.833 0 0 1 1.423.589v.833h5v-.833a.833.833 0 0 1 1.667 0v.833h.833a1.667 1.667 0 0 1 1.667 1.667v8.333a1.667 1.667 0 0 1-1.667 1.667h-10a1.667 1.667 0 0 1-1.666-1.667V8.667A1.667 1.667 0 0 1 7.33 7h.833v-.833c0-.221.088-.433.244-.589"
    />
    <rect
      width={2.667}
      height={2.667}
      x={10.67}
      y={11.661}
      fill="#fff"
      rx={0.667}
    />
  </svg>
);

/* Next Available Icon */
export const NextAvailableIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <circle cx={12} cy={12} r={12} fill="#DCFCE7" />
    <path
      fill="#15803D"
      fillRule="evenodd"
      d="M13 6a.667.667 0 0 1 .467.635v3.334h2.666a.667.667 0 0 1 .547 1.048l-4.667 6.667a.667.667 0 0 1-1.213-.382v-3.333H8.134a.667.667 0 0 1-.547-1.048l4.667-6.667A.667.667 0 0 1 13 6"
      clipRule="evenodd"
    />
  </svg>
);

/* Magic Optimise Icon */
export const MagicOptimiseIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <circle cx={12} cy={12} r={12} fill="#E2FFEC" />
    <path
      fill="#15803D"
      d="M16.15 5.76a.778.778 0 0 0-1.526 0l-.187.928a.778.778 0 0 1-.61.611l-.928.186a.778.778 0 0 0 0 1.528l.928.185a.778.778 0 0 1 .61.61l.186.929a.778.778 0 0 0 1.528 0l.185-.928a.778.778 0 0 1 .611-.611l.928-.186a.778.778 0 0 0 0-1.527l-.928-.186a.778.778 0 0 1-.61-.61zm-7.03 3.02a.778.778 0 0 0-1.476 0l-.532 1.596a.778.778 0 0 1-.493.493l-1.596.532a.778.778 0 0 0 0 1.477l1.596.532c.25.083.41.243.493.493l.532 1.596a.778.778 0 0 0 1.477 0l.532-1.596a.778.778 0 0 1 .493-.493l1.596-.532a.778.778 0 0 0 0-1.477l-1.596-.532a.778.778 0 0 1-.493-.493zm5.45 6.228a.778.778 0 0 0-1.477 0l-.143.429a.778.778 0 0 1-.492.493l-.43.143a.778.778 0 0 0 0 1.477l.43.143c.25.083.41.243.493.493l.142.428a.778.778 0 0 0 1.477 0l.143-.428a.778.778 0 0 1 .493-.493l.428-.143a.778.778 0 0 0 0-1.477l-.428-.143a.778.778 0 0 1-.493-.493z"
    />
  </svg>
);

/* Time Range Icon */
export const TimeRangeIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <circle cx={12} cy={12} r={12} fill="#F7EBFA" />
    <path
      fill="#B031C5"
      d="M10.5 8.5a.766.766 0 0 0-1.305-.538L5.12 11.96a.761.761 0 0 0 0 1.078l4.077 4.064a.766.766 0 0 0 1.305-.539zM13.5 8.5c0-.308.186-.585.472-.703a.762.762 0 0 1 .832.165l4.077 4.064a.761.761 0 0 1 0 1.078l-4.077 4.064a.766.766 0 0 1-.832.165.762.762 0 0 1-.472-.704z"
    />
  </svg>
);

/* Add to Calendar Icon */
export const AddToCalendarIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="#262338"
      d="M19 22H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1.6a.4.4 0 0 0 .4-.4V2.4c0-.22.18-.4.4-.4h1.2c.22 0 .4.18.4.4v1.2c0 .22.18.4.4.4h5.2a.4.4 0 0 0 .4-.4V2.4c0-.22.18-.4.4-.4h1.2c.22 0 .4.18.4.4v1.2c0 .22.18.4.4.4H19a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2M5.4 10a.4.4 0 0 0-.4.4v9.2c0 .22.18.4.4.4h13.2a.4.4 0 0 0 .4-.4v-9.2a.4.4 0 0 0-.4-.4zm0-4a.4.4 0 0 0-.4.4v1.2c0 .22.18.4.4.4h13.2a.4.4 0 0 0 .4-.4V6.4a.4.4 0 0 0-.4-.4zM13 17.6a.4.4 0 0 1-.4.4h-1.2a.4.4 0 0 1-.4-.4v-1.2a.4.4 0 0 0-.4-.4H9.4a.4.4 0 0 1-.4-.4v-1.2c0-.22.18-.4.4-.4h1.2a.4.4 0 0 0 .4-.4v-1.2c0-.22.18-.4.4-.4h1.2c.22 0 .4.18.4.4v1.2c0 .22.18.4.4.4h1.2c.22 0 .4.18.4.4v1.2a.4.4 0 0 1-.4.4h-1.2a.4.4 0 0 0-.4.4z"
    />
  </svg>
);

/* Add to Health Icon */
export const HealthIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.06 8.01h-1.005V7.007c0-.302-.1-.503-.301-.704s-.402-.301-.704-.301-.502.1-.703.301-.302.402-.302.704V8.01H8.04c-.301 0-.502.1-.703.301s-.302.402-.302.704.1.502.302.703c.2.201.502.302.703.302h1.005v1.005c0 .301.1.502.302.703.2.201.402.302.703.302.302 0 .503-.1.704-.302.2-.2.301-.402.301-.703V10.02h1.005c.302 0 .503-.1.704-.302.2-.2.301-.402.301-.703 0-.302-.1-.503-.301-.704s-.402-.301-.704-.301m6.23-6.029A6.2 6.2 0 0 0 14.272.172c-1.507-.1-3.015.302-4.22 1.206C8.743.474 7.235-.029 5.627.172c-1.607.201-3.014 1.005-4.12 2.211C.503 3.59.001 5.096.001 6.704.1 8.312.704 9.82 1.81 10.925l6.03 6.13q.904.905 2.11.905c.804 0 1.608-.302 2.11-.905l6.03-6.13c.603-.603 1.105-1.306 1.407-2.01.301-.804.502-1.608.502-2.412s-.1-1.608-.502-2.412a4.47 4.47 0 0 0-1.206-2.11m-1.406 7.537-6.03 6.03c-.1.1-.2.2-.301.2-.1.101-.302.101-.402.101s-.302 0-.402-.1-.201-.1-.302-.201l-6.03-6.03c-.803-.804-1.205-1.91-1.205-3.015s.402-2.21 1.206-3.014 1.909-1.206 3.014-1.206c1.106 0 2.211.402 3.015 1.206.1.1.201.2.302.2.1.101.301.101.402.101.1 0 .301 0 .402-.1.1-.101.2-.101.301-.201.804-.804 1.91-1.206 3.015-1.206s2.211.402 3.015 1.206 1.206 1.909 1.206 3.014c0 1.106-.402 2.211-1.206 3.015"
    />
  </svg>
);

/* Certificate Icon */
export const CertificateIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.5 10h1a1 1 0 0 0 0-2h-1a1 1 0 0 0 0 2m4 6h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2m0-4h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2m6.92-2.62a1 1 0 0 0-.21-1.09l-6-6a1 1 0 0 0-.28-.19.3.3 0 0 0-.09 0l-.28-.1H5.5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h6a1 1 0 0 0 0-2h-6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h4a1 1 0 0 0 .92-.62M13.5 8a1 1 0 0 1-1-1V5.41L15.09 8zm7 4h-5a1 1 0 0 0-1 1v8a1 1 0 0 0 .53.88 1 1 0 0 0 1-.05l1.97-1.3 2 1.3a1 1 0 0 0 1.5-.83v-8a1 1 0 0 0-1-1m-1 7.12-.94-.63a1 1 0 0 0-1.12 0l-.94.63V14h3z"
    />
  </svg>
);

/* Info Warning Icon */
export const InfoWarningIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        stroke="#D97706"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 7v5m0 4v.5M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

/* Info Icon */
export const InfoIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <g stroke="currentColor" strokeWidth={2} clipPath="url(#a)">
      <path d="M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1Z" />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 17v-5M12 8v-.5"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

/* Waving Icon */
export const WavingIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <g fill="currentColor" clipPath="url(#a)">
      <path d="m5.242 7.438-.025-.047c-.21-.373-.425-.743-.631-1.118a2.38 2.38 0 0 1-.28-1.56c.163-.998.72-1.678 1.66-2.01.624-.22 1.242-.162 1.838.127q.276.136.508.34l.049.041c.076-.102.144-.204.223-.298.369-.443.834-.729 1.395-.835.78-.149 1.478.045 2.085.569.218.188.389.416.531.669q.533.942 1.068 1.882l.392.69.03.05q.02-.023.034-.042c.43-.584 1-.923 1.71-1.009.51-.061.994.04 1.446.29.412.23.729.557.963.97.591 1.044 1.188 2.085 1.775 3.131q.549.983.795 2.087a7.9 7.9 0 0 1 .167 2.371 8 8 0 0 1-.22 1.318 7.8 7.8 0 0 1-.649 1.708 7.74 7.74 0 0 1-2.428 2.781 7.58 7.58 0 0 1-7.702.616 7.7 7.7 0 0 1-2.044-1.456 8.3 8.3 0 0 1-1.377-1.84c-.65-1.157-1.309-2.31-1.964-3.465l-1.255-2.212A2.5 2.5 0 0 1 3 9.993a2.47 2.47 0 0 1 .686-1.798c.346-.37.768-.6 1.257-.708.096-.021.195-.032.298-.049m9.287 2.14-.007-.016-1.19-2.098-1.362-2.398c-.206-.363-.405-.73-.619-1.086-.23-.382-.573-.559-1.013-.516-.607.058-1.032.65-.915 1.26.034.175.119.325.205.476l2.175 3.832a.76.76 0 0 1 .102.448.704.704 0 0 1-.795.636.72.72 0 0 1-.53-.386q-.751-1.327-1.504-2.653L7.642 4.552c-.19-.334-.478-.523-.856-.547a1 1 0 0 0-.88.401 1.07 1.07 0 0 0-.104 1.158q.237.429.482.856l2.278 4.014c.199.351.402.7.595 1.055a.705.705 0 0 1-.2.884.694.694 0 0 1-.894-.037c-.096-.09-.156-.206-.22-.318L6.36 9.403c-.344-.605-1.134-.73-1.627-.26-.365.35-.439.88-.18 1.337q.708 1.254 1.42 2.504.926 1.628 1.848 3.257c.386.684.87 1.283 1.466 1.787a6.23 6.23 0 0 0 3.608 1.465q.543.035 1.083-.025a6.212 6.212 0 0 0 3.912-1.98 6.3 6.3 0 0 0 1.307-2.138c.296-.81.43-1.646.393-2.51a6.6 6.6 0 0 0-.141-1.112 6.6 6.6 0 0 0-.716-1.86l-1.72-3.028a1.041 1.041 0 0 0-1.87.091c-.142.34-.116.67.064.988q.431.759.861 1.519.137.241.073.514a.74.74 0 0 1-.366.478q-.734.447-1.098 1.235-.314.679-.254 1.43.048.627.354 1.176a.72.72 0 0 1 .085.535.68.68 0 0 1-.514.531.64.64 0 0 1-.686-.218 1.8 1.8 0 0 1-.217-.366 4.25 4.25 0 0 1-.43-1.958 4.3 4.3 0 0 1 1.27-2.987q.118-.115.244-.23M16.2 2.003a5.1 5.1 0 0 1 2.292.582 5.2 5.2 0 0 1 2.166 2.11.71.71 0 0 1-.248.928.69.69 0 0 1-.92-.162c-.077-.103-.137-.22-.21-.327a3.84 3.84 0 0 0-1.557-1.346 3.6 3.6 0 0 0-1.238-.344q-.215-.018-.43-.028a.71.71 0 0 1-.646-.622.71.71 0 0 1 .595-.79c.064-.008.13-.001.196-.001M7.83 22a.7.7 0 0 1-.418-.126 10.5 10.5 0 0 1-1.764-1.569 10.7 10.7 0 0 1-1.325-1.841.72.72 0 0 1 .304-1.025.695.695 0 0 1 .877.256c.167.266.326.538.504.796a8.9 8.9 0 0 0 1.851 1.95c.13.102.27.193.396.3a.68.68 0 0 1 .235.714.68.68 0 0 1-.553.532c-.041.009-.085.01-.108.013" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M3 2h18v20H3z" />
      </clipPath>
    </defs>
  </svg>
);
